import { FC } from "react";

import { FooterLink } from "@/global";

export const FooterSocialLink: FC<FooterLink> = ({ url, icon, title }) => (
  <th scope="row" className="border-l border-r group relative">
    <div className="bg-white w-0 h-[calc(100%-1px)] group-hover:w-[calc(100%-1px)] transition-all absolute -z-10 duration-500" />
    <a
      href={url}
      rel="noreferrer"
      target="_blank"
      className="flex justify-between items-center social-link"
    >
      <div className="flex items-center gap-2 capitalize group-hover:text-black transition-all">
        <span className="hidden md:block opacity-100 group-hover:opacity-0 transition-all">
          {icon()}
        </span>
        {title}
      </div>
      <div>
        <svg
          className="h-4 w-4 stroke-white group-hover:hidden block"
          viewBox="0 0 24 24"
          strokeWidth="2"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3"
          />
        </svg>
        <svg
          className="h-4 w-4 stroke-black group-hover:block hidden"
          viewBox="0 0 24 24"
          strokeWidth="2"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3"
          />
        </svg>
      </div>
    </a>
  </th>
);
